
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Paintbrush, Shield, Languages, List, Calendar, FileText, Link as LinkIcon } from "lucide-react";
import { AppearanceTab } from "./AppearanceTab";
import { RolesTab } from "./RolesTab";
import { LanguageTab } from "./LanguageTab";
import { CategoryTab } from "./CategoryTab";
import { ScheduleTab } from "./ScheduleTab";
import { InvoicingTab } from "./InvoicingTab";
import { TrialLinkTab } from "./TrialLinkTab";

export function SettingsTabs() {
  const { t } = useTranslation("settings");
  const [selectedTab, setSelectedTab] = useState("appearance");

  return (
      <Tabs defaultValue={selectedTab} onValueChange={setSelectedTab} className="space-y-4">
        <TabsList className="flex w-full overflow-x-auto overflow-y-hidden gap-1 sm:gap-2 px-0 scrollbar-hide bg-transparent sm:bg-muted h-auto py-1 sm:h-10">
          <TabsTrigger value="appearance" className="flex items-center gap-2 whitespace-nowrap flex-shrink-0 min-w-fit">
            <Paintbrush className="h-4 w-4" />
            <span className="hidden sm:inline">{t("appearance.title")}</span>
          </TabsTrigger>
          <TabsTrigger value="roles" className="flex items-center gap-2 whitespace-nowrap flex-shrink-0 min-w-fit">
            <Shield className="h-4 w-4" />
            <span className="hidden sm:inline">{t("roles.title")}</span>
          </TabsTrigger>
          <TabsTrigger value="language" className="flex items-center gap-2 whitespace-nowrap flex-shrink-0 min-w-fit">
            <Languages className="h-4 w-4" />
            <span className="hidden sm:inline">{t("language.title")}</span>
          </TabsTrigger>
          <TabsTrigger value="schedule" className="flex items-center gap-2 whitespace-nowrap flex-shrink-0 min-w-fit">
            <Calendar className="h-4 w-4" />
            <span className="hidden sm:inline">{t("schedule.title")}</span>
          </TabsTrigger>
          <TabsTrigger value="categories" className="flex items-center gap-2 whitespace-nowrap flex-shrink-0 min-w-fit">
            <List className="h-4 w-4" />
            <span className="hidden sm:inline">{t("category.title")}</span>
          </TabsTrigger>
          <TabsTrigger value="invoicing" className="flex items-center gap-2 whitespace-nowrap flex-shrink-0 min-w-fit">
            <FileText className="h-4 w-4" />
            <span className="hidden sm:inline">{t("invoicing.title")}</span>
          </TabsTrigger>
          <TabsTrigger value="trial" className="flex items-center gap-2 whitespace-nowrap flex-shrink-0 min-w-fit">
            <LinkIcon className="h-4 w-4" />
            <span className="hidden sm:inline">{t("trialLink.title")}</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="appearance" className="space-y-4">
          <AppearanceTab />
        </TabsContent>

        <TabsContent value="roles" className="space-y-4">
          <RolesTab />
        </TabsContent>

        <TabsContent value="language" className="space-y-4">
          <LanguageTab />
        </TabsContent>

        <TabsContent value="schedule" className="space-y-4">
          <ScheduleTab />
        </TabsContent>

        <TabsContent value="categories" className="space-y-4">
          <CategoryTab />
        </TabsContent>

        <TabsContent value="invoicing" className="space-y-4">
          <InvoicingTab />
        </TabsContent>

        <TabsContent value="trial" className="space-y-4">
          <TrialLinkTab />
        </TabsContent>
      </Tabs>

  );
}
